import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { FormsModule } from '@angular/forms';

import { PanelModule } from 'primeng/panel';
import { ChartModule } from 'primeng/chart';
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { DescricaoConvenioComponent } from './descricao-convenio/descricao-convenio.component';


@NgModule({
  declarations: [DashboardComponent, DescricaoConvenioComponent],
  imports: [
    CommonModule,
    FormsModule,

    PanelModule,
    ChartModule,
    CarouselModule,
    ButtonModule,
    TagModule,
    CardModule,
    InputTextModule,

    DashboardRoutingModule
  ]
})
export class DashboardModule { }
